<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <nte-view-details>
        </nte-view-details> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import nteViewDetails from './todo-nte-view-details'
export default {
    components: {
        nteViewDetails
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-nte-view-details.vue